const t = "_buttonsContainer_1it2w_1", o = "_arrowButton_1it2w_6", n = "_disabled_1it2w_19", s = {
  buttonsContainer: t,
  arrowButton: o,
  disabled: n
};
export {
  o as arrowButton,
  t as buttonsContainer,
  s as default,
  n as disabled
};
//# sourceMappingURL=index.es2373.js.map
